import { istek, jetonYenile, kimlikIstegi } from './istemci';
import { erisimJetonuYaz } from './jeton-deposu';
import type { Semalar } from './sema';

/**
 * KİMLİK UÇLARI.
 *
 * Tipler `schema.d.ts`ten TÜRETİLİR; elle yazılmaz. 0.25.3'e kadar burada yedi
 * arayüz elle aynalanıyordu ve backend bir alanı yeniden adlandırsa derleyici
 * susuyordu.
 */

export type OturumIstemci = Semalar['GirisDto']['istemci'];
export type YetkiKapsam = Semalar['BenYetkiDto']['kapsam'];

export type AtamaOzeti = Semalar['AtamaOzetiDto'];
export type GirisKullanicisi = Semalar['GirisKullaniciDto'];
export type GirisYaniti = Semalar['GirisYanitDto'];
export type OturumOzeti = Semalar['OturumOzetiDto'];
export type EtkinYetki = Semalar['BenYetkiDto'];
export type BenYaniti = Semalar['BenYanitDto'];
export type AydinlatmaSurumu = Semalar['AydinlatmaSurumDto'];

/* ------------------------------------------------------------------ */

/**
 * Giriş.
 *
 * `kimlikIstegi` kullanılıyor: 401 alındığında yenileme denenmemeli.
 * Hatalı şifre girildiğinde yenileme çağırmak anlamsız bir istek üretir ve
 * varsa geçerli bir yenileme jetonunu boşuna döndürür.
 */
export async function giris(kullaniciAdi: string, sifre: string): Promise<GirisYaniti> {
  const yanit = await kimlikIstegi<GirisYaniti>('/kimlik/giris', {
    yontem: 'POST',
    govde: { kullaniciAdi, sifre, istemci: 'panel' satisfies OturumIstemci },
  });

  erisimJetonuYaz(yanit.erisimJetonu);
  return yanit;
}

export function cikis(): Promise<void> {
  return istek<void>('/kimlik/cikis', { yontem: 'POST' });
}

export function ben(): Promise<BenYaniti> {
  return istek<BenYaniti>('/kimlik/ben');
}

export function oturumlar(): Promise<OturumOzeti[]> {
  return istek<OturumOzeti[]>('/kimlik/oturumlar');
}

export function digerOturumlariKapat(): Promise<void> {
  return istek<void>('/kimlik/oturumlar/digerlerini-kapat', { yontem: 'POST' });
}

/**
 * Şifre değiştirir.
 *
 * SUNUCU TÜM OTURUMLARI DÜŞÜRÜR (veritabanı tetikleyicisi) ve yenileme
 * çerezini siler. Çağıran taraf kullanıcıyı giriş ekranına yollamalıdır;
 * "başarılı" deyip panelde bırakmak her isteğin 401 almasına yol açar.
 */
export function sifreDegistir(mevcutSifre: string, yeniSifre: string): Promise<void> {
  return istek<void>('/kimlik/sifre-degistir', {
    yontem: 'POST',
    govde: { mevcutSifre, yeniSifre },
  });
}

export function aydinlatmaSurumu(): Promise<AydinlatmaSurumu> {
  return istek<AydinlatmaSurumu>('/kimlik/aydinlatma');
}

export function aydinlatmaOnayla(surum: string): Promise<void> {
  return istek<void>('/kimlik/aydinlatma-onay', { yontem: 'POST', govde: { surum } });
}

/**
 * Açılışta oturumu çerezle geri kurar.
 *
 * Erişim jetonu yalnız bellekte tutulduğu için sayfa yenilendiğinde kaybolur;
 * yenileme çerezi ise tarayıcıda durur. Başarısızlık NORMALDİR — hiç giriş
 * yapmamış kullanıcıda çerez yoktur.
 */
export async function oturumuGeriKur(): Promise<GirisKullanicisi> {
  // Jetonu ve kullanıcıyı TEK çağrıda alır. Ayrı bir `/yenile` isteği
  // ikinci bir rotasyon başlatır ve ilk jetonu boşuna iptal ederdi.
  const sonuc = await jetonYenile<GirisKullanicisi>();
  return sonuc.kullanici;
}
